module.exports = __webpack_public_path__ + "img/101-d-01.prt.32a07d44.jpg";